//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ColumnMatchDisplayItem } from './ColumnMatchDisplayItem';
import { StudentImportColumn } from './Enums';

export class StudentColumnMatchDisplayItem extends ColumnMatchDisplayItem {
    Column: StudentImportColumn = StudentImportColumn.StudentFirstName;

    constructor(initializer?: Partial<StudentColumnMatchDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentColumnMatchDisplayItem";
}
